import React, { useRef } from "react";
import { Box } from "@mui/material";
import { MultiSelectHeader } from "./MultiSelectHeader";
import { MultiSelectSearch } from "./MultiSelectSearch";
import { MultiSelectList } from "./MultiSelectList";
import { MultiSelectActions } from "./MultiSelectActions";
import { useMultiSelect } from "./useMultiSelect";
import { useClickOutside } from "../../../hooks/useClickOutside";

export const MultiSelect = ({
    options,
    onChange,
    defaultSelected,
    showSearch,
    itemText,
    isTierSelector,
}) => {
    const {
        isOpen,
        searchTerm,
        selectedOptions,
        filteredOptions,
        handleToggle,
        handleSearch,
        handleOptionToggle,
        handleSelectAll,
        handleCancel,
        handleApply,
        handleClose,
    } = useMultiSelect(options, onChange, defaultSelected);
    const containerRef = useRef(null);
    useClickOutside(containerRef, handleClose);
    

    return (
        <Box ref={containerRef} sx={{ position: "relative", width: "12rem" }}>
            <MultiSelectHeader
                isOpen={isOpen}
                selectedOptions={selectedOptions}
                onToggle={handleToggle}
                totalCount={options?.length}
                itemText={itemText}
                tierOptions={options}
                
            />

            {isOpen && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        mt: 1,
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        boxShadow: 3,
                        border: "1px solid",
                        borderColor: "divider",
                        zIndex: 1000,
                        // p: 2,
                    }}
                >
                    {showSearch && (
                        <Box>
                            <MultiSelectSearch
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </Box>
                    )}

                    <MultiSelectList
                        options={filteredOptions}
                        selectedOptions={selectedOptions}
                        onOptionToggle={handleOptionToggle}
                        onSelectAll={handleSelectAll}
                        isTierSelector={isTierSelector}
                    />

                    <MultiSelectActions
                        onCancel={handleCancel}
                        onApply={handleApply}
                    />
                </Box>
            )}
        </Box>
    );
};
